module.exports = __webpack_public_path__ + "img/forgot-password1.1cf50487.png";